import { Link } from "react-router-dom";
import { Reveal, Label } from "@/components/motion";

export default function Intro() {
  return (
    <section data-testid="home-intro" className="bg-white">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-3">
            <Reveal>
              <Label>Urban Trail</Label>
            </Reveal>
          </div>
          <div className="lg:col-span-8 lg:col-start-5">
            <Reveal>
              <h2 className="max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                Travel should be more than a destination.
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-10 max-w-2xl text-lg leading-relaxed text-graphite">
                At Urban Trail, we believe the best journeys are thoughtfully planned,
                beautifully experienced and remembered for years to come. From the
                mountains of the Himalayas to tropical escapes and vibrant cities, we
                curate journeys around the places, people and experiences that make
                travel meaningful.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <Link
                to="/about"
                data-testid="intro-discover-link"
                className="link-arrow mt-10 text-ink hover:text-gold"
              >
                Discover Urban Trail
                <span aria-hidden>→</span>
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
